import { render, staticRenderFns } from "./RawMaterial.vue?vue&type=template&id=6d8960e2"
import script from "./RawMaterial.vue?vue&type=script&lang=js"
export * from "./RawMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports